import AxiosClient from "../../../services/axios.services";

class NotificationBodyServices {
  getNotificationBody = (params) =>
    AxiosClient.get(
      "/api/app/notificacion_correo/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getNotificationBodyByID = (id) =>
    AxiosClient.get(
      `/api/app/notificacion_correo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveNotificationBody = (data) =>
    AxiosClient.post(
      "/api/app/creacion_correo_envio/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editNotificationBody = (id, data) =>
    AxiosClient.put(
      `/api/app/notificacion_correo/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editNotificationSending = (id, data) =>
    AxiosClient.put(
      `/api/app/notificacion_envio_correo/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteNotificationBody = (id) =>
    AxiosClient.delete(
      `/api/app/notificacion_correo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new NotificationBodyServices();
